var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[(_vm.value)?_c('div',{staticClass:"modal frame-size"},[(_vm.hasCloseButton)?_c('default-button',{staticClass:"frame-button close-frame",on:{"clicked":function($event){return _vm.$emit('input', false)}}}):_vm._e(),_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }